(function(){
    'use strict';
    

    jcu_js_v1.fn.initResponsiveTables = function(){
        var responsiveTables = document.querySelectorAll('.jcu-v1__table--responsive');

        for (let index = 0; index < responsiveTables.length; index++) {
            const table = responsiveTables[index];

            var tableHeaders = table.querySelectorAll('th');
            for (let j = 0; j < tableHeaders.length; j++) {
                const header = tableHeaders[j];
              //  console.log(header.textContent.trim())
            }

            var tableRows = table.querySelectorAll('.jcu-v1__table--responsive__row');
            var strippedTableRows = [];
            for (let k = 0; k < tableRows.length; k++) {
                const tablerow = tableRows[k];
                
                if(tablerow.children.length === tableHeaders.length){
                    strippedTableRows.push(tablerow);
                }
            }
            
            for (let l = 0; l < strippedTableRows.length; l++) {
                var tds = strippedTableRows[l].querySelectorAll('td');
                for (let td_idx = 0; td_idx < tds.length; td_idx++) {
                    var td = tds[td_idx];
                   // console.log("herh" , td) ;
                    var headerLabel = tableHeaders[td_idx].textContent.trim();
                    td.setAttribute('data-label',headerLabel);
                }
                
                const element = strippedTableRows[l];
                
            }

           // console.log(strippedTableRows);
        }
    }

    jcu_js_v1.fn.updateSavedCoursePageElements = function(){
        var cookie = jcu_js_v1.fn.read_cookie(jcu_js_v1.vars.cookie_name);
        
        var number = document.querySelector('#no-of-saved-courses');
        if(cookie !== null){
            if (number !== null){
                number.textContent = cookie.length;
            }
        }
        
        

    }

    jcu_js_v1.fn.removeSavedCourseFromTable = function(e){
        var button = e.target;
        var courseAssetID = button.dataset.courseassetid;
        // console.log("HERE");
        jcu_js_v1.fn.checkSavedCoursesCookie(courseAssetID);
        
        button.parentNode.removeChild(button);
        var rowsToRemove = document.querySelectorAll('tr[data-courseassetid="'+courseAssetID + '"');
        for (let i = 0; i < rowsToRemove.length; i++) {
            const element = rowsToRemove[i];
            element.classList.add('jcu-v1__opacity__40-percent');
        }

        jcu_js_v1.fn.updateSavedCoursePageElements();
    }


    jcu_js_v1.fn.initSavedRemoval = function(){
        var allCloseButtons = document.querySelectorAll('.jcu-v1__btn__remove_course');

        for (let i = 0; i < allCloseButtons.length; i++) {
            const element = allCloseButtons[i];
            element.addEventListener('click', jcu_js_v1.fn.removeSavedCourseFromTable, false)
            
        }
    }


    //function filterlength(tablerow)
   // jcu-v1__table--responsive
   jcu_js_v1.fn.initResponsiveTables();
   jcu_js_v1.fn.initSavedRemoval();
}());
